import { IGameState } from '../../../../../../src/State/Game/IGameState';
import { AsyncActionStatus } from '../../../../../../src/State/AsyncAction';
import {
    IPlayerDataLocation,
    sortDataLocationSets,
} from '../../../../../../src/Utility/DataConflict/DataConflictsHelper';
import { completeConflictResolution } from '../../../../../../src/State/Game/DataConflict/DataConflict';
import { report } from 'report';

export function setConflicts(state: IGameState, dataSets: IPlayerDataLocation[]): IGameState {
    if (dataSets.length > 1) {
        try {
            const sortedDataSets = sortDataLocationSets(dataSets);

            return {
                ...state,
                gamePaused: true,
                dataConflict: {
                    status: AsyncActionStatus.IN_PROGRESS,
                    result: sortedDataSets,
                },
            };
        } catch (error) {
            report('Failed to handle data conflict', {
                error,
                once: true,
                sampleRate: 0.5,
                fingerprint: 'Facebook:setConflicts:FailedToHandle',
            });
            return completeConflictResolution(state, AsyncActionStatus.FAILED);
        }
    }
    // Complete conflict resolution if no conflicts
    return completeConflictResolution(state);
}
